/** Only delete caches known to belong to the account being signed out. */
export function accountCacheScope(userId, docs = []) {
  const localIds = new Set(docs.filter(doc => doc._storage === 'local').map(doc => doc.docId));
  return {
    userId,
    docIds: [...new Set(docs.filter(doc => doc._storage === 'online' && !localIds.has(doc.docId)).map(doc => doc.docId).filter(id => typeof id === 'string' && id))],
  };
}

export function accountCacheNames({ userId, docIds = [] } = {}) {
  if (typeof userId !== 'string' || !userId || userId.startsWith('local-')) return [];
  // Unknown caches and legacy recovery sources are deliberately not guessed.
  // Each online map: its content cache and the offline copies of its files.
  return [`orbital-user-v2-${userId}`, ...docIds.filter(id => typeof id === 'string' && id)
    .flatMap(id => [`orbital-${id}`, `orbital-offline-attachments-${id}`])];
}
